if (typeof require !== 'undefined') {
    require('es5-shim');
    require('es5-shim/es5-sham');
    require('console-polyfill');
    require('../../css/layout/popUp.css');
    require('es6-promise').polyfill();
}
//公共的外部方法
commonMethods = (function () {
    var _timer = {};
    return {
        //初始化中图分类法下拉数据
        getClassCodeName: function (graphClassCode, classCodeType) {
            var ajaxObj = $.ajax({
                url: ctxPath + '/redisSubjectName.do',
                data: {
                    "classCodeType": classCodeType,
                    'id': graphClassCode
                },
                type: "post",
                async: false,
                dataType: 'json',
            });
            return ajaxObj;
        },
        //获取cookie
        getCookieEvent: function (parames) {
            var basicStatisticsPageParam = $.parseJSON(localStorage.getItem('basicStatisticsPageParam'));//机构概览页面
            var subjectEvaluationPageParam = $.parseJSON(localStorage.getItem('subjectEvaluationPageParam'));//学科评估页面
            var otherPageParam = $.parseJSON(localStorage.getItem('otherPageParam'));//其他公用页面参数
            var multiContrastPageParam = $.parseJSON(localStorage.getItem('multiContrastPageParam'));
            var currentpage = $(".whitch-page").val();
            try {
                if (parames == 'characteristicEvaluation') {
                    return localStorage.getItem('characteristicEvaluation');
                }
                if (parames == 'isLoginPerson') {
                    return localStorage.getItem('isLoginPerson');
                }
                if (parames == 'isOnTrial') {
                    return localStorage.getItem('isOnTrial');
                }
                if (currentpage == 'basicStatisticsPage') {
                    return basicStatisticsPageParam[parames];
                } else if (currentpage == 'subjectEvaluationPage') {
                    return subjectEvaluationPageParam[parames];
                } else if (currentpage == 'basicStatisticsSubjectDetailPage' || currentpage == 'basicStatisticsDetailPage') {
                    return otherPageParam[parames];
                } else {
                    return multiContrastPageParam[parames];
                }
            } catch (e) {
                return '';
            }
        },
        //保存cookie
        saveCookieEvent: function (parames) {
            if (!this.hasLocalSotrage()) {
                initPopUpBg.popUp('您使用的浏览器不支持机构存储功能，请更换浏览器或登录个人账号');
            } else {
                //时间数据处理 不存在相关的时间数据存储的时候,保留原有的时间数据
                var date = new Date;
                var endYear = parames['endYear'];
                var startYear = parames['startYear'];
                var time = {};
                if (endYear && startYear) {
                    time['endTime'] = endYear;
                    time['startTime'] = startYear;
                } else {
                    time['endTime'] = date.getFullYear() - 1;
                    time['startTime'] = date.getFullYear() - 5;
                }
                var classCodeType = parames['classCodeType'];
                var currentpage = $(".whitch-page").val();
                var basicStatisticsPageParam = {};//机构概览页面
                var subjectEvaluationPageParam = {};//学科评估页面
                var multiContrastPageParam = {};//多维对比 与 学科透视
                var otherPageParam = {};//其他公用页面参数

                //封装个人表示
                localStorage.removeItem('isLoginPerson');
                if ($('#isLoginPerson').text() == 'true') {
                    localStorage.setItem("isLoginPerson", "true");
                } else {
                    localStorage.setItem("isLoginPerson", "false");
                }

                //封装机构权限状态
                localStorage.removeItem('isOnTrial');
                if ($("#isOnTrial").val() == 'true') {
                    localStorage.setItem("isOnTrial", "true");
                } else {
                    localStorage.setItem("isOnTrial", "false");
                }

                //首页参数存储(basicStatisticsPage)
                saveBasicStatisticsPageParam();
                //详情页面参数存储(subjectEvaluationPage)
                saveSubjectEvaluationPageParam();
                //学科评估页面参数存储(学科或指标)
                saveOtherPageParamParam();
                //特色评价页面检索参数
                saveEvaluationParam();
                //多维对比与学科透视
                saveMultiContrastPageParamParam();

                //首页参数存储
                function saveBasicStatisticsPageParam() {
                    //获取上一次存储的basicStatisticsPageParam
                    var basicStatisticsPageParamOld = JSON.parse(localStorage.getItem('basicStatisticsPageParam'));
                    localStorage.removeItem('basicStatisticsPageParam');
                    var basicStatisticsPageLeftparam = JSON.parse(JSON.stringify(parames));
                    //封装时间参数(学科评估页面不携带时间参数跳转 机构概览首页)
                    if (currentpage != 'subjectEvaluationPage') {
                        basicStatisticsPageParam['time'] = JSON.stringify(time);
                    } else {
                        //学科评估页面 保存上一次的时间数据
                        if (null != basicStatisticsPageParamOld && null != basicStatisticsPageParamOld.time) {
                            var basicStatisticsPageParamOldTime = JSON.parse(basicStatisticsPageParamOld.time);
                            basicStatisticsPageLeftparam['endYear'] = basicStatisticsPageParamOldTime.endTime;
                            basicStatisticsPageLeftparam['startYear'] = basicStatisticsPageParamOldTime.startTime;
                            basicStatisticsPageParam['time'] = JSON.stringify({
                                "endTime": basicStatisticsPageParamOldTime.endTime,
                                "startTime": basicStatisticsPageParamOldTime.startTime
                            });
                        } else {
                            basicStatisticsPageParam['time'] = JSON.stringify({
                                "endTime": date.getFullYear() - 1,
                                "startTime": date.getFullYear() - 5
                            });
                        }
                    }
                    //封装学科类型
                    basicStatisticsPageParam['classCodeType'] = 'educationClassCode';
                    basicStatisticsPageLeftparam['classCodeType'] = 'educationClassCode';
                    //封装学科分类号
                    basicStatisticsPageParam['secondLevelName'] = JSON.stringify({"all": "全部"});
                    //封装左侧整体参数
                    basicStatisticsPageLeftparam['graphClassCode'] = 'all';
                    basicStatisticsPageLeftparam['classCodeType'] = classCodeType;
                    basicStatisticsPageLeftparam['classCodeKey'] = '';
                    //对标选择参数处理
                    var datumLineInstall = commonMethods.datumLineInstall(basicStatisticsPageLeftparam['datumLineName']);
                    basicStatisticsPageLeftparam['datumLine'] = datumLineInstall.datumLineEvaluationOther;
                    basicStatisticsPageLeftparam['datumLineName'] = datumLineInstall.datumLineEvaluationOtherName;
                    var datumLine = {
                        'datumLine': datumLineInstall.datumLineEvaluationOther,
                        'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                    };
                    basicStatisticsPageParam['datumLine'] = JSON.stringify(datumLine);
                    basicStatisticsPageParam['leftParames'] = $.param(basicStatisticsPageLeftparam, true);
                    //数据存储
                    localStorage.setItem('basicStatisticsPageParam', JSON.stringify(basicStatisticsPageParam));
                }

                //学科评估参数存储
                function saveSubjectEvaluationPageParam() {
                    var subjectEvaluationPageLeftparam = JSON.parse(JSON.stringify(parames));
                    var localStorageSaveClassCodeSave = {};
                    localStorage.removeItem('subjectEvaluationPageParam');
                    //学科号
                    var classCodeArrSave = subjectEvaluationPageLeftparam['graphClassCode'];
                    var isSaveClassCode = false;
                    if (currentpage == 'multiContrastPage' || currentpage == 'themeAnalysisPage' || currentpage == 'talentAnalysisPage') {
                        if (null != classCodeArrSave && "02" != classCodeArrSave && classCodeArrSave[0] != 'install') {
                            var classCodeValue = classCodeArrSave[0];
                            if (classCodeValue && '' != classCodeValue && 'install' != classCodeValue) {
                                var classCodeName = commonMethods.getClassCodeName(classCodeValue, classCodeType);
                                var renturnClassCode = JSON.parse(classCodeName.responseText);
                                localStorageSaveClassCodeSave[renturnClassCode.classCode] = renturnClassCode.classCodeName;
                                subjectEvaluationPageLeftparam['graphClassCode'] = renturnClassCode.classCode;//修改mainURL
                                subjectEvaluationPageLeftparam['endYear'] = '2018';//修改mainURL
                                subjectEvaluationPageLeftparam['startYear'] = '2014';//修改mainURL
                                //封装学科类型
                                subjectEvaluationPageParam['classCodeType'] = classCodeType;
                                subjectEvaluationPageLeftparam['classCodeType'] = classCodeType;
                                isSaveClassCode = true;
                            }
                        }
                    }
                    if (!isSaveClassCode) {
                        if (classCodeType == 'graphClassCode') {
                            subjectEvaluationPageLeftparam['graphClassCode'] = 'F';
                            localStorageSaveClassCodeSave['F'] = '经济';
                            subjectEvaluationPageParam['classCodeType'] = 'graphClassCode';
                            subjectEvaluationPageLeftparam['classCodeType'] = 'graphClassCode';
                        }
                        if (classCodeType == 'educationClassCode') {
                            subjectEvaluationPageLeftparam['graphClassCode'] = '02';
                            localStorageSaveClassCodeSave['02'] = '经济学类';
                            subjectEvaluationPageParam['classCodeType'] = 'educationClassCode';
                            subjectEvaluationPageLeftparam['classCodeType'] = 'educationClassCode';
                        }
                    }
                    //封装时间参数
                    subjectEvaluationPageParam['time'] = JSON.stringify({'endTime': '2018', 'startTime': '2014'});
                    //封装学科分类号
                    subjectEvaluationPageParam['secondLevelName'] = JSON.stringify(localStorageSaveClassCodeSave);
                    //封装左侧整体参数
                    subjectEvaluationPageLeftparam['classCodeType'] = classCodeType;
                    subjectEvaluationPageLeftparam['classCodeKey'] = '';
                    //对标选择处理
                    var datumLineInstall = commonMethods.datumLineInstall(subjectEvaluationPageLeftparam['datumLineName']);
                    subjectEvaluationPageLeftparam['datumLine'] = datumLineInstall.datumLineEvaluationOther;
                    subjectEvaluationPageLeftparam['datumLineName'] = datumLineInstall.datumLineEvaluationOtherName;
                    var datumLine = {
                        'datumLine': datumLineInstall.datumLineEvaluationOther,
                        'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                    };
                    subjectEvaluationPageParam['datumLine'] = JSON.stringify(datumLine);

                    subjectEvaluationPageParam['leftParames'] = $.param(subjectEvaluationPageLeftparam, true);
                    //数据存储
                    localStorage.setItem('subjectEvaluationPageParam', JSON.stringify(subjectEvaluationPageParam));
                }

                //多维对比与学科透视
                function saveMultiContrastPageParamParam() {
                    //获取上一次存储的multiContrastPageParam
                    var multiContrastPageParamLeftparamOld = $.parseJSON(localStorage.getItem('multiContrastPageParam'));

                    var multiContrastPageParamLeftparam = JSON.parse(JSON.stringify(parames));
                    var localStorageSaveClassCodeSave = {};
                    localStorage.removeItem('multiContrastPageParam');
                    //学科号
                    var classCodeArrSave = multiContrastPageParamLeftparam['graphClassCode'];
                    var classCodeFlag = false;
                    if (currentpage == 'basicStatisticsDetailPage'
                        || currentpage == 'subjectEvaluationPage'
                        || currentpage == 'multiContrastPage'
                        || currentpage == 'themeAnalysisPage'
                        || currentpage == 'talentAnalysisPage') {
                        if (null != classCodeArrSave && "02" != classCodeArrSave && classCodeArrSave[0] != 'install') {
                            for (var classCodekey in classCodeArrSave) {
                                var classCodeValue = classCodeArrSave[classCodekey];
                                if (classCodeValue && '' != classCodeValue && 'install' != classCodeValue) {
                                    var classCodeName = commonMethods.getClassCodeName(classCodeValue, classCodeType);
                                    var renturnClassCode = JSON.parse(classCodeName.responseText);
                                    localStorageSaveClassCodeSave[renturnClassCode.classCode] = renturnClassCode.classCodeName;
                                } else {
                                    localStorageSaveClassCodeSave['all'] = '全部';
                                }
                            }
                        } else {
                            if ("02" != classCodeArrSave) {
                                localStorageSaveClassCodeSave['all'] = '全部';
                            } else {
                                localStorageSaveClassCodeSave['02'] = '经济学类';
                            }
                        }
                        //封装学科类型
                        multiContrastPageParam['classCodeType'] = classCodeType;
                        multiContrastPageParamLeftparam['classCodeType'] = classCodeType;
                        classCodeFlag = true;
                    }
                    if (!classCodeFlag) {
                        // 去除上一次存储的学科分类号
                        if (null != multiContrastPageParamLeftparamOld && null != multiContrastPageParamLeftparamOld.leftParames) {
                            var classCodeArrSaveleftParames = multiContrastPageParamLeftparamOld['leftParames'];
                            var leftParames = commonMethods.saveCookieEventLeftParam(classCodeArrSaveleftParames);
                            var classCodeArrSave = leftParames['graphClassCode'];
                            var classCodeArrSavekey = leftParames['classCodeKey'];
                            var isclassCodeArrSaveSize = false;
                            for (var classCodekey in classCodeArrSave) {
                                var classCodeValue = classCodeArrSave[classCodekey];
                                if (classCodeValue && '' != classCodeValue && 'install' != classCodeValue) {
                                    var classCodeName = commonMethods.getClassCodeName(classCodeValue, leftParames['classCodeType']);
                                    var renturnClassCode = JSON.parse(classCodeName.responseText);
                                    localStorageSaveClassCodeSave[renturnClassCode.classCode] = renturnClassCode.classCodeName;
                                } else {
                                    localStorageSaveClassCodeSave['all'] = '全部';
                                }
                                isclassCodeArrSaveSize = true;
                            }
                            if (!isclassCodeArrSaveSize) {
                                localStorageSaveClassCodeSave['all'] = '全部';
                            }
                            multiContrastPageParamLeftparam['graphClassCode'] = classCodeArrSave;
                            multiContrastPageParamLeftparam['classCodeKey'] = classCodeArrSavekey;
                            //封装学科类型
                            multiContrastPageParam['classCodeType'] = leftParames['classCodeType'];
                            multiContrastPageParamLeftparam['classCodeType'] = leftParames['classCodeType'];
                        } else {
                            //封装学科类型
                            multiContrastPageParam['classCodeType'] = 'educationClassCode';
                            multiContrastPageParamLeftparam['classCodeType'] = 'educationClassCode';
                            localStorageSaveClassCodeSave['all'] = '全部';
                            multiContrastPageParamLeftparam['graphClassCode'] = 'all';
                        }
                    }

                    //封装学科分类号
                    multiContrastPageParam['secondLevelName'] = JSON.stringify(localStorageSaveClassCodeSave);
                    //封装时间参数(学科评估页面不携带时间参数跳转 多维对比 与 学科透视)
                    if (currentpage != 'subjectEvaluationPage') {
                        multiContrastPageParam['time'] = JSON.stringify(time);
                    } else {
                        //学科评估页面 保存上一次的时间数据
                        if (null != multiContrastPageParamLeftparamOld && null != multiContrastPageParamLeftparamOld.time) {
                            var multiContrastPageParamOldTime = JSON.parse(multiContrastPageParamLeftparamOld.time);
                            multiContrastPageParamLeftparam['endYear'] = multiContrastPageParamOldTime.endTime;
                            multiContrastPageParamLeftparam['startYear'] = multiContrastPageParamOldTime.startTime;
                            multiContrastPageParam['time'] = JSON.stringify({
                                "endTime": multiContrastPageParamOldTime.endTime,
                                "startTime": multiContrastPageParamOldTime.startTime
                            });
                        } else {
                            multiContrastPageParam['time'] = JSON.stringify({
                                "endTime": date.getFullYear() - 1,
                                "startTime": date.getFullYear() - 5
                            });
                        }
                    }
                    //对标选择处理
                    var datumLineInstall = commonMethods.datumLineInstall(multiContrastPageParamLeftparam['datumLineName']);
                    multiContrastPageParamLeftparam['datumLine'] = datumLineInstall.datumLineEvaluationOther;
                    multiContrastPageParamLeftparam['datumLineName'] = datumLineInstall.datumLineEvaluationOtherName;
                    var datumLine = {
                        'datumLine': datumLineInstall.datumLineEvaluationOther,
                        'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                    };
                    multiContrastPageParam['datumLine'] = JSON.stringify(datumLine);
                    multiContrastPageParam['leftParames'] = $.param(multiContrastPageParamLeftparam, true);
                    //数据存储
                    localStorage.setItem('multiContrastPageParam', JSON.stringify(multiContrastPageParam));
                }

                //其他页面参数存储
                function saveOtherPageParamParam() {
                    //获取上一次存储的otherPageParam
                    var otherPageParamLeftparamOld = $.parseJSON(localStorage.getItem('otherPageParam'));

                    var otherPageParamLeftparam = JSON.parse(JSON.stringify(parames));
                    var localStorageSaveClassCodeSave = {};
                    localStorage.removeItem('otherPageParam');

                    //学科号
                    var classCodeArrSave = otherPageParamLeftparam['graphClassCode'];
                    var classCodeFlag = false;
                    if (currentpage != 'basicStatisticsPage') {//首頁不携帶學科數據
                        if (null != classCodeArrSave && "02" != classCodeArrSave && classCodeArrSave[0] != 'install') {
                            for (var classCodekey in classCodeArrSave) {
                                var classCodeValue = classCodeArrSave[classCodekey];
                                if (classCodeValue && '' != classCodeValue && 'install' != classCodeValue) {
                                    var classCodeName = commonMethods.getClassCodeName(classCodeValue, classCodeType);
                                    var renturnClassCode = JSON.parse(classCodeName.responseText);
                                    localStorageSaveClassCodeSave[renturnClassCode.classCode] = renturnClassCode.classCodeName;
                                } else {
                                    localStorageSaveClassCodeSave['all'] = '全部';
                                }
                            }
                        } else {
                            if ("02" != classCodeArrSave) {
                                localStorageSaveClassCodeSave['all'] = '全部';
                            } else {
                                localStorageSaveClassCodeSave['02'] = '经济学类';
                            }
                        }
                        //封装学科类型
                        otherPageParam['classCodeType'] = classCodeType;
                        otherPageParamLeftparam['classCodeType'] = classCodeType;
                        classCodeFlag = true;
                    }
                    if (!classCodeFlag) {
                        // 去除上一次存储的学科分类号
                        if (null != otherPageParamLeftparamOld && null != otherPageParamLeftparamOld.leftParames) {

                            var classCodeArrSaveleftParames = otherPageParamLeftparamOld['leftParames'];
                            var leftParames = commonMethods.saveCookieEventLeftParam(classCodeArrSaveleftParames);
                            var classCodeArrSave = leftParames['graphClassCode'];
                            var classCodeArrSavekey = leftParames['classCodeKey'];
                            var isclassCodeArrSaveSize = false;
                            for (var classCodekey in classCodeArrSave) {
                                var classCodeValue = classCodeArrSave[classCodekey];
                                if (classCodeValue && '' != classCodeValue && 'install' != classCodeValue) {
                                    var classCodeName = commonMethods.getClassCodeName(classCodeValue, leftParames['classCodeType']);
                                    var renturnClassCode = JSON.parse(classCodeName.responseText);
                                    localStorageSaveClassCodeSave[renturnClassCode.classCode] = renturnClassCode.classCodeName;
                                } else {
                                    localStorageSaveClassCodeSave['all'] = '全部';
                                }
                                isclassCodeArrSaveSize = true;
                            }
                            if (!isclassCodeArrSaveSize) {
                                localStorageSaveClassCodeSave['all'] = '全部';
                            }
                            otherPageParamLeftparam['graphClassCode'] = classCodeArrSave;
                            otherPageParamLeftparam['classCodeKey'] = classCodeArrSavekey;
                            //封装学科类型
                            otherPageParam['classCodeType'] = leftParames['classCodeType'];
                            otherPageParamLeftparam['classCodeType'] = leftParames['classCodeType'];
                        } else {
                            localStorageSaveClassCodeSave['all'] = '全部';
                            otherPageParamLeftparam['graphClassCode'] = 'all';
                            otherPageParam['classCodeType'] = 'educationClassCode';
                            otherPageParamLeftparam['classCodeType'] = 'educationClassCode';
                        }
                    }
                    //封装学科分类号
                    otherPageParam['secondLevelName'] = JSON.stringify(localStorageSaveClassCodeSave);
                    //时间参数处理
                    otherPageParam['time'] = JSON.stringify(time);

                    //封装学科分类号
                    otherPageParam['secondLevelName'] = JSON.stringify(localStorageSaveClassCodeSave);
                    //对标选择处理
                    var datumLineInstall = commonMethods.datumLineInstall(otherPageParamLeftparam['datumLineName']);
                    otherPageParamLeftparam['datumLine'] = datumLineInstall.datumLineEvaluationOther;
                    otherPageParamLeftparam['datumLineName'] = datumLineInstall.datumLineEvaluationOtherName;
                    var datumLine = {
                        'datumLine': datumLineInstall.datumLineEvaluationOther,
                        'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                    };
                    otherPageParam['datumLine'] = JSON.stringify(datumLine);
                    otherPageParam['leftParames'] = $.param(otherPageParamLeftparam, true);
                    //数据存储
                    localStorage.setItem('otherPageParam', JSON.stringify(otherPageParam));
                }

                //特色评价页面检索参数
                function saveEvaluationParam() {
                    localStorage.removeItem('characteristicEvaluation');
                    var evaluationParamLeftparam = JSON.parse(JSON.stringify(parames));
                    //特色评价参数
                    var saveName = '';
                    //解码操作 获取当前选中的数据
                    var jsonUnit = decodeURIComponent(evaluationParamLeftparam["unitNameCombinationString"]);
                    var jsonUnit = JSON.parse(jsonUnit);
                    var unitActive = 0;
                    try {
                        unitActive = parames["unitActive"][0];
                    } catch (e) {
                        unitActive = parames["unitActive"]
                    }
                    var ijsonUnit = 0;
                    for (var item in jsonUnit) {
                        if (jsonUnit.hasOwnProperty(item)) {
                            if (ijsonUnit == unitActive) {
                                saveName = jsonUnit[item][0];
                                break;
                            }
                        }
                        ijsonUnit++;
                    }
                    localStorage.setItem('characteristicEvaluation', saveName);
                }
            }
        },
        //(初始化核心方法)      封装左侧参数
        saveCookieEventLeftParam: function (parames) {
            var paramesObj = {};
            var urlArr = parames.split('&');
            var graphClassCodeArr = [];
            var graphKeyClassCodeArr = [];
            var unitActiveArr = [];
            var classCodeType;
            var startTime;
            var endTime;
            var len = urlArr.length;
            for (var i = 0; i < len; i++) {
                var nameArr = urlArr[i].split('=');
                if (nameArr[0] == 'classCodeType') {
                    if (nameArr[1] == 'graphClassCode') {
                        classCodeType = 'graphClassCode';
                    }
                    if (nameArr[1] == 'educationClassCode') {
                        classCodeType = 'educationClassCode';
                    }
                } else if (nameArr[0] == 'graphClassCode') {
                    graphClassCodeArr.push(decodeURIComponent(nameArr[1]));
                } else if (nameArr[0] == 'classCodeKey') {
                    graphKeyClassCodeArr.push(nameArr[1]);
                } else if (nameArr[0] == 'unitActive') {
                    unitActiveArr.push(nameArr[1]);
                } else if (nameArr[0] == 'startYear') {
                    startTime = nameArr[1];
                } else if (nameArr[0] == 'endYear') {
                    endTime = nameArr[1];
                } else {
                    if (nameArr[0] == 'unitNameCombinationString') {
                        nameArr[1] = decodeURIComponent(nameArr[1]);
                    }
                    paramesObj[nameArr[0]] = nameArr[1];
                }
            }
            //学科类型数据处理
            paramesObj["classCodeType"] = classCodeType;
            paramesObj["graphClassCode"] = graphClassCodeArr;
            paramesObj["classCodeKey"] = graphKeyClassCodeArr;
            paramesObj["startYear"] = startTime;
            paramesObj["endYear"] = endTime;
            paramesObj["unitActive"] = unitActiveArr;
            return paramesObj;
        },
        saveCookieEventDef: function () {
            var basicStatisticsPageParam = {};//机构概览页面
            var subjectEvaluationPageParam = {};//学科评估页面
            var multiContrastPageParam = {};//多维对比 与 学科透视
            var otherPageParam = {};//其他公用页面参数
            //首页参数存储(basicStatisticsPage)
            saveBasicStatisticsPageParam();
            //详情页面参数存储(subjectEvaluationPage)
            saveSubjectEvaluationPageParam();
            //学科评估页面参数存储(学科或指标)
            saveOtherPageParamParam();
            //多维对比 与 学科透视
            saveMultiContrastPageParam();

            //首页参数存储
            function saveBasicStatisticsPageParam() {
                basicStatisticsPageParam['secondLevelName'] = JSON.stringify({"all": "全部"});
                var datumLineInstall = commonMethods.datumLineInstall();
                var datumLine = {
                    'datumLine': datumLineInstall.datumLineEvaluationOther,
                    'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                };
                basicStatisticsPageParam['datumLine'] = JSON.stringify(datumLine);
                //数据存储
                localStorage.setItem('basicStatisticsPageParam', JSON.stringify(basicStatisticsPageParam));
            }

            //学科评估参数存储
            function saveSubjectEvaluationPageParam() {
                subjectEvaluationPageParam['secondLevelName'] = JSON.stringify({"F": "经济"});
                ;
                var datumLineInstall = commonMethods.datumLineInstall();
                var datumLine = {
                    'datumLine': datumLineInstall.datumLineEvaluationOther,
                    'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                };
                subjectEvaluationPageParam['datumLine'] = JSON.stringify(datumLine);
                //数据存储
                localStorage.setItem('subjectEvaluationPageParam', JSON.stringify(subjectEvaluationPageParam));
            }

            //其他页面参数存储
            function saveOtherPageParamParam() {
                otherPageParam['secondLevelName'] = JSON.stringify({"all": "全部"});
                var datumLineInstall = commonMethods.datumLineInstall();
                var datumLine = {
                    'datumLine': datumLineInstall.datumLineEvaluationOther,
                    'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                };
                otherPageParam['datumLine'] = JSON.stringify(datumLine);
                //数据存储
                localStorage.setItem('basicStatisticsPageParam', JSON.stringify(otherPageParam));
            }

            //多维对比 与 学科透视
            function saveMultiContrastPageParam() {
                multiContrastPageParam['secondLevelName'] = JSON.stringify({"all": "全部"});
                var datumLineInstall = commonMethods.datumLineInstall();
                var datumLine = {
                    'datumLine': datumLineInstall.datumLineEvaluationOther,
                    'datumLineName': datumLineInstall.datumLineEvaluationOtherName
                };
                multiContrastPageParam['datumLine'] = JSON.stringify(datumLine);
                //数据存储
                localStorage.setItem('multiContrastPageParam', JSON.stringify(multiContrastPageParam));
            }
        },
        //对标选择处理
        datumLineInstall: function (markeValueName) {
            if (!markeValueName || markeValueName == 'undefined') {
                markeValueName = 'B+';
            }
            var datumLineEvaluationOther = '';
            var datumLineEvaluationOtherName = '';
            if (markeValueName == 'A+') {
                datumLineEvaluationOther = '3';
                datumLineEvaluationOtherName = 'A+';
            }
            if (markeValueName == 'A') {
                datumLineEvaluationOther = '7';
                datumLineEvaluationOtherName = 'A';
            }
            if (markeValueName == 'A-') {
                datumLineEvaluationOther = '14';
                datumLineEvaluationOtherName = 'A-';
            }
            if (markeValueName == 'B+') {
                datumLineEvaluationOther = '28';
                datumLineEvaluationOtherName = 'B+';
            }
            if (markeValueName == 'B') {
                datumLineEvaluationOther = '44';
                datumLineEvaluationOtherName = 'B';
            }
            if (markeValueName == 'B-') {
                datumLineEvaluationOther = '57';
                datumLineEvaluationOtherName = 'B-';
            }
            if (markeValueName == 'C+') {
                datumLineEvaluationOther = '71';
                datumLineEvaluationOtherName = 'C+';
            }
            if (markeValueName == 'C') {
                datumLineEvaluationOther = '87';
                datumLineEvaluationOtherName = 'C';
            }
            if (markeValueName == 'C-') {
                datumLineEvaluationOther = '100';
                datumLineEvaluationOtherName = 'C-';
            }
            if (markeValueName == '前5%') {
                datumLineEvaluationOther = '5';
                datumLineEvaluationOtherName = '前5%';
            }
            if (markeValueName == '前10%') {
                datumLineEvaluationOther = '10';
                datumLineEvaluationOtherName = '前10%';
            }
            if (markeValueName == '前20%') {
                datumLineEvaluationOther = '20';
                datumLineEvaluationOtherName = '前20%';
            }
            if (markeValueName == '前30%') {
                datumLineEvaluationOther = '30';
                datumLineEvaluationOtherName = '前30%';
            }
            if (markeValueName == '前40%') {
                datumLineEvaluationOther = '40';
                datumLineEvaluationOtherName = '前40%';
            }
            if (markeValueName == '前50%') {
                datumLineEvaluationOther = '50';
                datumLineEvaluationOtherName = '前50%';
            }
            if (markeValueName == '前60%') {
                datumLineEvaluationOther = '60';
                datumLineEvaluationOtherName = '前60%';
            }
            if (markeValueName == '前70%') {
                datumLineEvaluationOther = '70';
                datumLineEvaluationOtherName = '前70%';
            }
            if (markeValueName == '前80%') {
                datumLineEvaluationOther = '80';
                datumLineEvaluationOtherName = '前80%';
            }
            if (markeValueName == '前90%') {
                datumLineEvaluationOther = '90';
                datumLineEvaluationOtherName = '前90%';
            }
            return {
                'datumLineEvaluationOther': datumLineEvaluationOther,
                'datumLineEvaluationOtherName': datumLineEvaluationOtherName
            };
        },
        //判断浏览器是否支持 localSotrage
        hasLocalSotrage: function () {
            return window.Storage && window.localStorage && window.localStorage instanceof Storage
        },
        //公共滚动条事件
        scrollCommon: function (obj) {
            $(document).ready(function () {
                obj.getNiceScroll().show();
                obj.getNiceScroll().resize();
                obj.niceScroll({
                    cursorcolor: "#1e69bc",//滚动条的颜色
                    cursoropacitymax: 1, //滚动条的透明度，从0-1
                    touchbehavior: false, //使光标拖动滚动像在台式电脑触摸设备
                    cursorwidth: "8px", //滚动条的宽度
                    cursorborder: "0", // 游标边框css定义
                    cursorborderradius: "3px",//以像素为光标边界半径  圆角
                    autohidemode: 'leave', //是否隐藏滚动条  true的时候默认不显示滚动条，当鼠标经过的时候显示滚动条
                    background: '#ddd',
                    cursorfixedheight: 20,
                    zindex: 10000,
                    railpadding: {top: 0, right: 0, left: 0, bottom: 0}//滚动条的位置
                });
            });
        },
        loadScript: function (url, callback) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState == "loaded" || script.readyState == "complete") {
                        script.onreadystatechange = null;
                        callback();
                    }
                }
            } else {
                script.onload = function () {
                    callback();
                }
            }

            script.src = url;
            document.getElementsByTagName("head")[0].appendChild(script);
        },
        //判断浏览器版本
        browserType: function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                return true;
            } else if (isEdge) {
                return true;//edge
            } else if (isIE11) {
                return true; //IE11
            } else {
                return false;//不是ie浏览器
            }
        },
        //判断小于ie9浏览器版本
        iebrowserType: function () {
            var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
            var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
            var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
            var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
            if (isIE) {
                var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
                reIE.test(userAgent);
                var fIEVersion = parseFloat(RegExp["$1"]);
                if (fIEVersion >= 11) {
                    return false;
                } else {
                    return true;
                }
            } else if (isEdge) {
                return false;//edge
            } else if (isIE11) {
                return false; //IE11
            } else {
                return false;//不是ie浏览器
            }
        },
        //防止多次点击
        moreClickEvent: function (id, fn, wait) {
            if (_timer[id]) {
                window.clearTimeout(_timer[id]);
                delete _timer[id];
            }

            return _timer[id] = window.setTimeout(function () {
                fn();
                delete _timer[id];
            }, wait);

        },
        //禁止多次发送
        ajaxPrefilterEvent: function (url) {
            var pendingRequests = {};
            $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
                var key = options.url;
                if (key == url) {
                    if (!pendingRequests[key]) {
                        pendingRequests[key] = jqXHR;
                    } else {
                        pendingRequests[key].abort(); // 放弃先触发的提交
                    }
                }
            });
        },
        //日期格式化
        dateFormat: function (fmt) {
            var _this = new Date();
            var o = {
                "M+": _this.getMonth() + 1, //月份
                "d+": _this.getDate(), //日
                "h+": _this.getHours(), //小时
                "m+": _this.getMinutes(), //分
                "s+": _this.getSeconds(), //秒
                "q+": Math.floor((_this.getMonth() + 3) / 3), //季度
                "S": _this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (_this.getFullYear() + "").substr(4 - RegExp.$1.length));
            }
            for (var k in o) {
                if (new RegExp("(" + k + ")").test(fmt)) {
                    var curReg = '';
                    if (RegExp.$1.length == 1) {
                        curReg = o[k];
                    } else {
                        curReg = ("00" + o[k]).substr(("" + o[k]).length);
                    }
                    fmt = fmt.replace(RegExp.$1, curReg);
                }
            }
            return fmt;
        },
        //过滤特殊字符
        filterWords: function (name) {
            var regEn = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im,
                regCn = /[·！#￥（——）：；“”‘、，|《。》？、【】[\]]/im;

            if (regEn.test(name) || regCn.test(name)) {
                return true;
            }
            return false;
        },
        //获取url参数值
        getQueryString: function (name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return (r[2]);
            return null;
        },
        arrUniqueEvent: function (arr) {
            var hash = [];
            for (var i = 0; i < arr.length; i++) {
                for (var j = i + 1; j < arr.length; j++) {
                    if (arr[i] === arr[j]) {
                        ++i;
                    }
                }
                hash.push(arr[i]);
            }
            return hash;
        }
    }
})();
//导出弹窗以及错误提示弹窗
initPopUpBg = (function () {
    var backPopUp = $('.me-error-popUp');
    var errorPop = $('.me-error-popUp-hasButton');
    var exportPopUp = $('.me-common-pop');
    var exportPar = $('.me-export-pop');
    var orgNameInput = exportPar.find('.pop-first .org-name');
    var nameWrapper = exportPopUp.find('.subject-name-wrapper');
    var selectList = exportPopUp.find('.select-list');
    var noticeWrapper = $('.notice-wrapper');
    return {
        popUp: function (str) {
            backPopUp.fadeIn(200);
            $('#me-error-text').text(str);
        },
        hasButtonPop: function (str) {
            errorPop.fadeIn(200);
            errorPop.find('.me-error-text').text(str);
        },
        //导出弹窗
        exportPop: function (str) {
            exportPar.fadeIn(200);
            exportPar.find('.pop-first .org-name').val(str);
            if (!commonMethods.browserType()) {
                orgNameInput.next().fadeIn();
            }
        },
        //关闭按钮事件
        closeBtn: function () {
            backPopUp.find('.icon-close').click(function () {
                backPopUp.fadeOut(200);
                noticeWrapper.css('visibility', 'hidden');
            });
            exportPopUp.find('.close-btn').click(function () {
                exportPopUp.fadeOut(200);
                noticeWrapper.css('visibility', 'hidden');
            });
            exportPopUp.find('.btn-reset').click(function () {
                exportPopUp.fadeOut(200);
                noticeWrapper.css('visibility', 'hidden');
            });
            errorPop.find('.icon-close').click(function () {
                errorPop.fadeOut(200);
                noticeWrapper.css('visibility', 'hidden');
            });
            errorPop.find('.btn-reset').click(function () {
                errorPop.fadeOut(200);
                noticeWrapper.css('visibility', 'hidden');
            });
        },
        getError: function () {
            var currentFileName = $.trim(orgNameInput.val());
            if (!currentFileName) {
                noticeWrapper.css('visibility', 'visible');
            } else {
                noticeWrapper.css('visibility', 'hidden');
            }
        },
        //导出的文件名称事件
        orgNameEvent: function () {
            var that = this;
            orgNameInput.focus(function () {
                if ($.trim($(this).val())) {
                    if (!commonMethods.browserType()) {
                        $(this).next().fadeIn();
                        that.getError();
                    }
                }
            });
            orgNameInput.keyup(function () {
                if (!commonMethods.browserType()) {
                    $(this).next().fadeIn();
                    that.getError();
                }
            });
            orgNameInput.next().click(function () {
                $(this).prev().val('');
                $(this).fadeOut();
            });
        },
        //导出文件类型下拉事件
        selectListEvent: function () {
            nameWrapper.click(function (e) {
                var newE = e || window.event;
                newE.stopPropagation();
                $(this).next('.select-list').slideDown(200);
            });
            selectList.on('click', 'a', function (e) {
                var newE = e || window.event;
                newE.stopPropagation();
                var value = $(this).text();
                var id = $(this).attr('data-id');
                $(this).parents('.input-wrapper').find('.org-name').html(value).attr('data-id', id);
                $(this).parent().slideUp(200);
            });
        },

        init: function () {
            this.closeBtn();
            this.orgNameEvent();
            this.selectListEvent();
        }
    }
})();

$(function () {
    initPopUpBg.init();
    //动态导入html2canvasjs
    if (!commonMethods.iebrowserType()) {
        commonMethods.loadScript(ctxPath + '/page/webpack-project/content/src/js/lib/html2canvas.min.js', function () {
        });
    }
    //加入报告弹窗
    addReportMethod = (function () {
        var loginParent = $('.anxs-8qwe-list-login');
        var grLogin = loginParent.find('.anxs-8qwe-login-gr');
        var reportBtn = $('.me-detail-wrapper .me-addPort-btn');
        var reportOk = $('.me-report-ok');
        var reportPar = $('.me-report-pop');
        var mainNav = $('.me-main-nav');
        var ltOrg = $('.lt-org');
        var ltOrgList = ltOrg.find('.lt-content-list');
        var isMultiContrast = $('.whitch-page').val();
        var currentCanvas = '';
        var currentExportType = '', currentExportFunctionType = '', currentExportIsTable = '';
        return {
            //加入报告弹窗
            reportPop: function () {
                var that = this;
                reportBtn.click(function () {
                    var isOver = $(this).attr('data-isover');
                    if (isOver == 'true') {
                        currentCanvas = $(this).parent().prev();
                        var $this = $(this);
                        $.ajax({
                            url: ctxPath + '/judgeUser.do',
                            dataType: 'json',
                            type: 'post',
                            async: true,
                            success: function (data) {
                                if (data[0] !== false) {
                                    reportPar.fadeIn();
                                    currentExportType = mainNav.find('.wrapper-text-list>.list-nav.active').attr('data-type');
                                    currentExportFunctionType = $this.parent().prev().attr('data-type');
                                    currentExportIsTable = $this.parent().attr('data-type');
                                    that.getPopListEvent();
                                } else {
                                    $('html').animate({
                                        scrollTop: 0
                                    }, 100, function () {
                                        grLogin.trigger('click');
                                    });
                                }
                            }
                        });
                    }
                });
            },
            //查询报告（下拉）
            getPopListEvent: function () {
                $.ajax({
                    url: ctxPath + '/reportExport/selectExportGroup.do',
                    dataType: 'json',
                    type: 'post',
                    async: true,
                    success: function (data) {
                        var html = '<a data-id="0">未分组</a>';
                        var par = reportPar.find('.select-list');
                        if (data.length > 0) {
                            var len = data.length;
                            for (var i = 0; i < len; i++) {
                                var curPar = data[i];
                                if (curPar["exportGroupName"].length > 16) {
                                    html += '<a data-id="' + curPar.exportGroupID + '" title="' + curPar["exportGroupName"] + '">' + curPar["exportGroupName"] + '</a>';
                                } else {
                                    html += '<a data-id="' + curPar.exportGroupID + '">' + curPar["exportGroupName"] + '</a>';
                                }
                            }
                            par.html(html);
                            var height = par.find('a').outerHeight();
                            var allHeight = height * len;
                            if (allHeight > 200) {
                                par.css('height', '');
                                commonMethods.scrollCommon(par);
                            } else {
                                par.css('height', 'auto');
                            }
                        } else {
                            par.html(html);
                            par.css('height', 'auto');
                        }
                    }
                });
            },
            getActiveUnitName: function (parames) {
                var orgArr = {};
                var par = '';
                if (isMultiContrast == 'multiContrastPage') {
                    par = ltOrgList.find('.list-item .active').parent();
                } else {
                    par = ltOrgList.find('.list-item .circle-hover').parent();
                }
                var detail = par.find('.data-detail').text();
                if (detail.indexOf("[") > 0 || detail.indexOf("]") > 0) {
                    detail = detail.substring(1, detail.length - 1).replace(/"/g, '');
                }
                detail = detail.split(',');
                var value = par.find('.item-info').text();
                orgArr[value] = detail;
                orgArr = encodeURIComponent(JSON.stringify(orgArr));
                parames["activeUnitName"] = orgArr;
            },
            //加入报告确定按钮
            reportOkBtn: function () {
                var that = this;
                reportPar.find('.btn-ok').click(function () {
                    var $this = $(this);
                    try {
                        html2canvas(currentCanvas[0], {
                            allowTaint: true,
                            taintTest: false,
                            logging: false
                        }).then(function (canvas) {
                            var dataURL = canvas.toDataURL();
                            var parames = $.extend(true, {}, mainUrl);
                            that.getActiveUnitName(parames);
                            var orgNamePar = $this.parent().prev().find('.org-name');
                            var groupId = orgNamePar.attr('data-id');
                            parames['unitNameCombinationString'] = parames['activeUnitName'];
                            parames['imgBase'] = dataURL;
                            parames['exportType'] = currentExportType;
                            parames['exportFunctionType'] = currentExportFunctionType;
                            parames['exportGroupID'] = groupId;
                            parames['isTable'] = currentExportIsTable ? currentExportIsTable : '';
                            reportPar.fadeOut();
                            $.ajax({
                                url: ctxPath + '/reportExport/saveExoprtIMG.do',
                                data: parames,
                                dataType: 'json',
                                type: 'post',
                                async: true,
                                traditional: true,
                                success: function (data) {
                                    if (data) {
                                        reportOk.find('#me-ok-text').text('已成功加入报告！');
                                        reportOk.fadeIn();
                                        var curUrl = $.extend({}, true, mainUrl);
                                        var detailUrl = $.param(curUrl, true);
                                        reportOk.find('p .open-report').attr('href', ctxPath + '/analysisReportIndex.do?id=' + groupId + '&' + detailUrl);
                                        setTimeout(function () {
                                            reportOk.fadeOut();
                                        }, 3000);
                                        orgNamePar.text('未分组').attr('data-id', '0');
                                    } else {
                                        initPopUpBg.popUp('加入报告失败');
                                    }
                                }
                            });
                        });
                    } catch (e) {
                        reportPar.fadeOut(200);
                        initPopUpBg.popUp('您的浏览器版本过低，建议您升级浏览器后查看');
                    }

                });
                reportPar.find('.close-btn').click(function () {
                    reportPar.fadeOut(200);
                    $(this).parents('.org-group-wrapper').find('.lt-content-input .org-name').text('未分组').attr('data-id', '0');
                });
                reportPar.find('.btn-reset').click(function () {
                    reportPar.fadeOut(200);
                    $(this).parents('.org-group-wrapper').find('.lt-content-input .org-name').text('未分组').attr('data-id', '0');
                });
            },
            //报告弹窗
            reportClose: function () {
                reportOk.find('.icon-close').click(function () {
                    reportOk.fadeOut(200);
                });
            },
            init: function () {
                this.reportPop();
                this.reportClose();
                this.reportOkBtn();
            }
        };
    })();
    addReportMethod.init();
});